<template>
  <div class="container">
    <custom-select
      label="Tipo de documento"
      :value="value"
      :name="name"
      :disabled="forzarDNE"
      @input="onChange"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      :items="tiposDocumentos"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { tiposDocumentos } from "@/config/constants";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "DocumentType",
  components: { CustomSelect },
  props: {
    value: String,
    name: String,
    forzarDNE: {
      type: Boolean,
      default: false
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      valueCache: this.value
    };
  },
  computed: {
    tiposDocumentos() {
      return Object.keys(tiposDocumentos).map(item => {
        return {
          label: item,
          value: tiposDocumentos[item]
        };
      });
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
      /**
       * Este valueCache sirve para en caso de forzar
       * DNE volver al valor previamente seleccionado
       * si el forzar vuelve a false
       */
      this.valueCache = val;
    }
  },
  watch: {
    /**
     * Escuchar el prop forzarDNE.
     * Si cambia a TRUE forzamos el tipo de doc a DNE
     */
    forzarDNE: function(newVal, oldVal) {
      if (newVal !== oldVal && newVal === true) {
        // Debemos forzar DNE
        this.$emit("input", tiposDocumentos["DNE"]);
      } else {
        // Volvemos al valor previamente seleccionado
        this.$emit("input", this.valueCache);
      }
    }
  }
};
</script>
